import { Head, router, usePage } from "@inertiajs/react";

import Layout from "/AdminLayout";
import ProjectForm from "/components/Admin/ProjectForm";

import { useToast } from "/utils/toast-context.jsx";
import createProjectStore from "/hooks/stores/projectStore";

const NewProject = ({
  project,
}) => {
  const useProjectStore = createProjectStore(project);
  const { errors } = usePage().props;
  const { successToast, errorToast } = useToast();

  const handleSubmit = (state, preview = false) => {
    const data = useProjectStore.getState().getAllData();
    data.state = state;
    if (preview)
      data.preview = preview;
    router.post(
      "/admin/projects",
      data,
      {
        forceFormData: true,
        preserveScroll: true,
        onSuccess: () => successToast("Сохранено"),
      }
    );
  };

  return (
    <>
      <Head>
        <title>Новый проект</title>
      </Head>

      <ProjectForm
        onSubmit={handleSubmit}
        useStore={useProjectStore}
        errors={errors}
      />
    </>
  );
}

NewProject.layout = (page) => <Layout children={page} />;

export default NewProject;
